import axios from 'axios';

const apiURL = "https://api.trumpauto.eu/b/";

const fetchSettings = async (headers) => {
  try{
    const response = await axios.get(apiURL+"settings", {headers: headers});
    return response.data;

  } catch(error){
    throw error;
  }
  
}

const fetchVehicleTypes = async (headers) => {
  try{
    const response = await axios.get(apiURL+"vehicle-types", {headers: headers});
    return response.data;

  } catch(error){
    throw error;
  }
  
}

const fetchMakes = async (headers) => {
  try{
    const response = await axios.get(apiURL+"vehicle-makes", {headers: headers});
    return response.data;

  } catch(error){
    throw error;
  }
  
}

const fetchHolidays = async (headers) => {
  try{
    const response = await axios.get(apiURL+"holidays", {headers: headers});
    return response.data;

  } catch(error){
    throw error;
  }
  
}

const fetchLocations = async (typeId, makeId, headers) => {
  try{
    const response = await axios.get(apiURL+"locations?vehicleType="+typeId+"&vehicleMake="+makeId, {headers: headers});
    return response.data;

  } catch(error){
    throw error;
  }
  
}

const fetchServiceTypes = async (locationId, typeId, makeId, headers) => {
  try {
    const serviceTypesResponse = await axios.get(apiURL+"locations/"+locationId+"/service-types?vehicleType="+typeId+"&vehicleMake="+makeId, {headers: headers});
    return serviceTypesResponse.data;

  } catch (error) {
    throw error;
  }

}

const fetchSchedule = async (locationId, date, serviceIds, headers) => {
  try {
    const url = apiURL+"locations/"+locationId+"/schedule?date="+date+"&services="+serviceIds.join(",");
    const getScheduleResponse = await axios.get(url, {headers: headers});
    return getScheduleResponse.data.availableBookingTimes;

  } catch (error) {
    throw error;
  }

}


export {fetchLocations, fetchServiceTypes, fetchSchedule, fetchSettings, fetchVehicleTypes, fetchMakes, fetchHolidays};